import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M27.53 15.652h-5.02L20 11.305l-2.51 4.347h-5.02L14.98 20l-2.51 4.348h5.02L20 28.696l2.51-4.348h5.02L25.02 20l2.51-4.348ZM23.085 20l-1.542 2.671h-3.084l-1.542-2.67 1.542-2.672h3.084L23.084 20ZM20 14.658l.574.994h-1.148l.574-.994Zm-4.626 2.671h1.148l-.574.994-.574-.994Zm0 5.342.574-.994.574.994h-1.148ZM20 25.341l-.574-.993h1.148l-.574.994Zm4.626-2.67h-1.148l.574-.994.574.994Zm-1.148-5.342h1.148l-.574.994-.573-.994ZM32.45 4.348H7.55a20.101 20.101 0 0 0-4.614 5.217h34.129a20.105 20.105 0 0 0-4.615-5.217ZM7.55 35.652h24.9a20.102 20.102 0 0 0 4.615-5.217H2.935a20.105 20.105 0 0 0 4.615 5.217Z"
}, null, -1), s = [
  o,
  n
];
function c(r, a) {
  return e(), t("svg", h, [...s]);
}
const Z = { render: c };
export {
  Z as default,
  c as render
};
